import React from 'react';
import BmbCta from '../BmbCta';
import MkBtn from '../MkBtn';
import MkPill from '../MkPill';
import bmbIcon from '../../../assets/images/mk/mk-bmb-icon-192.webp';
import { kmoPlayHref } from '../../../marketing/links';
import { mkTrack } from '../../../marketing/track';

const kmoLogo = require('../../../assets/images/logo-icon.svg').default;

const ROWS = [
  {
    dt: 'Best for',
    kmo: 'Study sessions, bedtime and focused work — when you want the phone out of reach.',
    bmb: 'The in-between moments — the app you open without thinking.',
  },
  {
    dt: 'What it does',
    kmo: 'Locks your whole phone for the time you choose, or on a schedule.',
    bmb: 'Shows a short, mindful pause before the apps you choose, and blocks adult content on your phone.',
  },
  {
    dt: 'How firm',
    kmo: 'Firm. Built to be hard to cancel on impulse.',
    bmb: 'Gentle. After the pause, you decide.',
  },
  {
    dt: 'Works on',
    kmo: 'Android 6.0 and up',
    bmb: 'iPhone (iOS 15.1 and up) and Android 7.0 and up',
  },
  {
    dt: 'Price',
    kmo: 'Free to download, with ads. Optional Premium.',
    bmb: 'Free to download. Optional Premium.',
  },
  {
    dt: 'Track record',
    kmo: '1M+ downloads on Google Play',
    bmb: 'New',
  },
];

const Rows = ({ app }) => (
  <dl className="mk-compare__dl">
    {ROWS.map((r) => (
      <div className="mk-compare__row" key={r.dt}>
        <dt>{r.dt}</dt>
        <dd>{r[app]}</dd>
      </div>
    ))}
  </dl>
);

// H8 — which app fits which moment, with the platform limits impossible to miss.
const HomeCompare = ({ platform }) => {
  const ios = platform === 'ios';
  return (
    <section className={`mk-compare section${ios ? ' mk-compare--ios' : ''}`} id="compare" aria-labelledby="mk-compare-title">
      <div className="container">
        <div className="section-inner">
          <div className="mk-head reveal-from-bottom">
            <p className="mk-eyebrow">Keep Me Out + Bring Me Back</p>
            <h2 id="mk-compare-title" className="mk-h2">
              Lock or pause? Pick the one that fits.
            </h2>
            <p className="mk-lead">Two different tools for two different moments. Use one, or pair them.</p>
          </div>
          <div className="mk-compare__grid">
            <article
              className="mk-card mk-compare__card mk-compare__card--kmo reveal-from-bottom"
              aria-labelledby="mk-compare-kmo"
            >
              <header className="mk-compare__head">
                <span className="mk-compare__logo mk-compare__logo--kmo">
                  <img src={kmoLogo} alt="" width={32} height={32} />
                </span>
                <div className="mk-compare__name">
                  <h3 id="mk-compare-kmo" className="mk-h3">
                    Keep Me Out
                  </h3>
                  <p className="mk-compare__pills">
                    <MkPill variant="platform">Android</MkPill>
                  </p>
                  <p className="mk-compare__sub">The lock</p>
                </div>
              </header>
              <Rows app="kmo" />
              <div className="mk-compare__cta">
                {ios ? (
                  <p className="mk-platform-note">Keep Me Out is Android-only.</p>
                ) : (
                  <MkBtn
                    variant="kmo"
                    href={kmoPlayHref('home_compare')}
                    sub="Google Play"
                    onClick={() => mkTrack('store_click', 'kmo:play:home_compare')}
                  >
                    Get Keep Me Out
                  </MkBtn>
                )}
              </div>
            </article>

            <div className="mk-compare__seam" aria-hidden="true">
              <span className="mk-compare__node">or both</span>
            </div>

            <article
              className="mk-card mk-compare__card mk-compare__card--bmb reveal-from-bottom"
              data-reveal-delay="150"
              aria-labelledby="mk-compare-bmb"
            >
              <header className="mk-compare__head">
                <img className="mk-compare__logo" src={bmbIcon} alt="" width={56} height={56} loading="lazy" decoding="async" />
                <div className="mk-compare__name">
                  <h3 id="mk-compare-bmb" className="mk-h3">
                    Bring Me Back
                  </h3>
                  <p className="mk-compare__pills">
                    <MkPill variant="new">New</MkPill>
                    <MkPill variant="platform">iPhone</MkPill>
                    <MkPill variant="platform">Android</MkPill>
                  </p>
                  <p className="mk-compare__sub">The pause</p>
                </div>
              </header>
              <Rows app="bmb" />
              <div className="mk-compare__cta">
                <BmbCta variant="button" placement="home_compare" platform={platform} />
              </div>
            </article>
          </div>
          <p className="mk-micro mk-compare__foot">
            Bring Me Back is a separate app with its own download and its own optional Premium.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HomeCompare;
